import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor() { }

   getValue(key:string): string | null {
    return localStorage.getItem('theme');
  }
}
